import React, { useEffect, useState } from "react";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";
import Swal from "sweetalert2";
import Select from 'react-select';
import { useLocation, useNavigate } from "react-router-dom";
const Operator = () => {
  const [formData, setFormData] = useState({
    badgeId: "",
    name: "",
    mobile: "",
    altMobile: "",
    department: ""
  });
  const code = localStorage.getItem('code');
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const location = useLocation();
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const rowData = location.state?.rowData;
  useEffect(() => {
    if (rowData) {
      setFormData({
        badgeId: rowData?.badgeId,
        name: rowData?.fullName,
        mobile: rowData?.mobileNo,
        altMobile: rowData?.alternateMobileNo,
        department:rowData?.department
      });
    }
  }, [rowData]);
  const fetchDepartments = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/departments', {
        params: { code: code },

        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        // Pass 'centerCode' as a parameter in the request
      });

      // Map the response data to options for the Select component
      const options = response.data.map((dept) => ({
        value: dept.name,
        label: dept.name,
      }));


      // setdepartmentGroupOptions(deparmentOptions)
      setDepartments(options);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };
  useEffect(() => {
    fetchDepartments();
  }, [code]);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      badgeId: formData?.badgeId,
      name: formData?.name,
      mobileNo: formData?.mobile,
      alternateMobileNo: formData?.altMobile,
      department:formData?.department,
      centerCode: code,       // optional: replace with real value
      createdBy: email,
      updatedBy: rowData ? email : ''  // optional: replace with logged-in user
    }
    try {
      if (rowData) {
        // UPDATE
        await apiClient.put(`${SERVER_BASE}/updateOperator/${rowData?.id}`, payload);
        Swal.fire({
          icon: "success",
          title: "Updated successfully",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
          timerProgressBar: 3000
        }).then(() => {
          navigate('../operatorList')
        });
      } else {
        // CREATE
        await apiClient.post(`${SERVER_BASE}/saveOperator`, payload);
        Swal.fire({
          icon: "success",
          title: "Saved successfully",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
          timerProgressBar: 3000
        }).then(() => {
          navigate('../operatorList')
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: err?.response.data.message,
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };



  return (
    <div className="formcontainer mt-5">
      <button className="btn btn-secondary btn-sm" onClick={() => { navigate('../operatorList') }}>Back</button>
      <h4 className="mb-3">Operator</h4>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-2">
            <label className="form-label">Badge ID</label>
            <input
              type="text"
              className="form-control"
              name="badgeId"
              value={formData.badgeId}
              onChange={handleChange}
              placeholder="Enter Badge ID"
              required
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter Name"
              required
            />
          </div>

          <div className="col-md-2">
            <label className="form-label">Mobile No</label>
            <input
              type="tel"
              className="form-control"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="Enter Mobile No"
              required
            />
          </div>

          <div className="col-md-2 mb-2">
            <label className="form-label">Alternate Mobile No</label>
            <input
              type="tel"
              className="form-control"
              name="altMobile"
              value={formData.altMobile}
              onChange={handleChange}
              placeholder="Enter Alternate Mobile No"
            />
          </div>
          <div className="col-md-3 mb-2">
            <label className="form-label">Department</label>
            <Select
              options={departments} 
              value={departments.find(dep => dep.value == formData?.department)} // Find selected option
              onChange={(selected) => setFormData({
                ...formData,
                department: selected?.value,
              })} // Update state
              placeholder="Select department"
              isClearable
            />
          </div>
        </div>
        <div className="text-end">
          <button type="submit" className="btn btn-success">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Operator;
